import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const DaswatchSvgIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 2H15L15.8276 6.13823C17.7379 7.38816 19 9.5467 19 12C19 14.4533 17.7379 16.6118 15.8276 17.8618L15 22H9L8.17235 17.8618C6.26206 16.6118 5 14.4533 5 12C5 9.5467 6.26206 7.38816 8.17235 6.13823L9 2ZM12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17ZM13 9V11.5858L14.7071 13.2929L13.2929 14.7071L11.2929 12.7071L11 12.4142V12V9H13Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};

export default DaswatchSvgIcon;
